import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, scrollToId } from "@/constants/site";

const LINKS = [
  { id: "services", label: "Дейности" },
  { id: "gallery", label: "Галерия" },
  { id: "reviews", label: "Отзиви" },
  { id: "booking", label: "Запиши час" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="font-display text-lg font-800 tracking-tight"
          aria-label="АутоДе 1 ЕООД - начало"
        >
          <span className="font-extrabold">АУТО</span>
          <span className="font-extrabold text-[#39FF14]">ДЕ·1</span>
        </button>

        <nav className="hidden items-center gap-8 md:flex" aria-label="Основна навигация">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-semibold uppercase tracking-widest text-zinc-400 transition-colors duration-300 hover:text-[#39FF14]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="nav-call-button"
            href={PHONE_TEL}
            className="hidden items-center gap-2 bg-[#39FF14] px-5 py-2.5 text-sm font-bold text-black transition-colors duration-300 hover:bg-[#32E612] sm:flex"
          >
            <Phone size={16} strokeWidth={2.5} />
            {PHONE_DISPLAY}
          </a>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            className="text-white md:hidden"
            aria-label="Меню"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden border-t border-white/10 bg-black/90 backdrop-blur-xl md:hidden"
          >
            <div className="flex flex-col px-5 py-4">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="border-b border-white/5 py-3 text-left text-sm font-semibold uppercase tracking-widest text-zinc-300"
                >
                  {l.label}
                </button>
              ))}
              <a
                data-testid="nav-mobile-call-button"
                href={PHONE_TEL}
                className="mt-4 flex items-center justify-center gap-2 bg-[#39FF14] px-5 py-3 text-sm font-bold text-black"
              >
                <Phone size={16} strokeWidth={2.5} />
                Обади се: {PHONE_DISPLAY}
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
